/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Seniority_SeniorInputs */

const en_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const de_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const fr_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const es_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const it_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const nl_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const pl_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const fi_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniori`)
};

const da_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

const sv_salary_seniority_senior = /** @type {(inputs: Salary_Seniority_SeniorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senior`)
};

/**
* | output |
* | --- |
* | "Senior" |
*
* @param {Salary_Seniority_SeniorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_seniority_senior = /** @type {((inputs?: Salary_Seniority_SeniorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Seniority_SeniorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_seniority_senior(inputs)
	if (locale === "fr") return fr_salary_seniority_senior(inputs)
	if (locale === "es") return es_salary_seniority_senior(inputs)
	if (locale === "it") return it_salary_seniority_senior(inputs)
	if (locale === "nl") return nl_salary_seniority_senior(inputs)
	if (locale === "pl") return pl_salary_seniority_senior(inputs)
	if (locale === "fi") return fi_salary_seniority_senior(inputs)
	if (locale === "da") return da_salary_seniority_senior(inputs)
	if (locale === "sv") return sv_salary_seniority_senior(inputs)
	return en_salary_seniority_senior(inputs)
});